import styled from "styled-components"

import {SummaryButtons as Wrapper} from "@irati-web/reward/src/components/styled"

export const GreyBackground = styled.div`
  ${({theme}) => `background-color: ${theme.colors.greys.lightest};`}
  padding: 30px;
  margin: 0 -20px -20px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: 30px 45px;
    margin: 0 -45px 20px;
  `}
`

export const SummaryButtons = styled(Wrapper)`
  margin-top: 40px;
`
